import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0, // Axios handles retries internally
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5, // 5 minutes default
    },
    mutations: {
      retry: 0,
    },
  },
});
